import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';

type logInspirationalListCarouselDisplayedParams = {
  carousel_length?: number;
  inspirational_list_types?: string[];
  location: CardLocation;
};

/**
 * a carousel that contains inspirational lists is displayed to user.
 * @param params - Attributes to log with the amplitude event
 * @param params.carousel_length - Total number of cards in the carousel.
 * @param params.inspirational_list_types - Inspirational list types of the lists displayed within the carousel (programmatic list, sponsored list, trail, etc,), passed from server
 * @param params.location - The location of the inspirational list carousel
 */
const logInspirationalListCarouselDisplayed = (
  { carousel_length, inspirational_list_types, location }: logInspirationalListCarouselDisplayedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'inspirational list carousel displayed',
    { 'carousel length': carousel_length, 'inspirational list types': inspirational_list_types, location },
    callback
  );
};

export default logInspirationalListCarouselDisplayed;
